module.exports = __webpack_public_path__ + "b406daa3dc5f79c0053167c6422ea8f0.svg";